<template>
  <v-card
    :width="$vuetify.breakpoint.smAndDown ? '100%' : '360px'"
    light
    class="rounded-md"
  >
    <v-card-title
      primary-title
      style="background-color: black; text-align: left"
      class="pa-6"
      color="white"
    >
      <span style="font-family: Inter; color: white" class="text-h5">
        <v-icon color="white" style="margin-top: -5px">mdi-bell-sleep</v-icon>
        Snooze Alert
      </span>
    </v-card-title>
    <v-col class="pa-6">
      <v-card-text class="pa-0" color="black">
        <span style="font-family: Inter; font-weight: 600">
          Duration
        </span></v-card-text
      >
      <v-select
        v-model="duration"
        :items="durations"
        single-line
        outlined
        label="Choose a chain type"
        dense
        color="black"
      ></v-select>
      <div style="text-align: right">
        <v-btn
          large
          depressed
          text
          class="ml-4 rounded-md no-active-btn"
          @click="$emit('cancel')"
        >
          <span
            style="
              font-family: Inter;
              text-transform: none;
              font-weight: 600;
              margin-top: -3px;
            "
            >Cancel</span
          >
        </v-btn>
        <v-btn
          depressed
          large
          :color="saveButtonColor"
          class="rounded-md ml-4 white--text pr-3"
          :disbled="!authStatus"
          @click="silenceAlert"
        >
          <span
            style="
              font-family: Inter;
              text-transform: none;
              font-weight: 600;
              margin-top: -3px;
            "
            >Save</span
          >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-card>
</template>

<script>
import axios from 'axios';
import { flatten } from '../../../utils/flatten';
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    alertSource: {
      type: String,
      default: '',
    },
    alertMetric: {
      type: String,
      default: '',
    },
    alertUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      durations: [
        { value: '900', text: '15 minutes' },
        { value: '3600', text: '1 hour' },
        { value: '86400', text: '24 hours' },
        { value: '-1', text: 'Forever' },
      ],
      duration: { value: '-1', text: 'Forever' },
      is_silenced: false,
    };
  },
  computed: {
    ...mapState({
      authStatus: (state) => state.auth.status,
    }),
    saveButtonColor() {
      return this.authStatus ? 'black' : 'grey';
    },
  },
  mounted() {
    let chains = this.$store.state.chain.chains;
    let nodes = flatten(chains.map((chain) => chain.nodes));
    let alerts = flatten(nodes.map((node) => node.alerts)).concat(
      flatten(chains.map((chain) => chain.alerts))
    );

    let matchingAlerts = alerts.filter(
      (alert) =>
        alert.source_id == this.alertSource &&
        alert.metric == this.alertMetric &&
        alert.url == this.alertUrl
    );

    if (matchingAlerts.length > 0) {
      this.is_silenced = matchingAlerts[0].is_silenced;
      if (this.is_silenced) {
        this.durations = [{ value: '0', text: 'Un-silence' }];
        this.duration = '0';
      }
    }
  },
  methods: {
    ...mapActions(['updateSilencedStatus']),
    async silenceAlert() {
      if (!this.authStatus) {
        return;
      }
      let silenceLength = parseInt(this.duration);
      let silenceUntil = null;
      if (silenceLength <= 0) {
        silenceUntil = null;
      } else {
        silenceUntil = new Date(new Date().getTime() + silenceLength * 1000);
      }
      let payload = {
        source_id: this.alertSource,
        metric: this.alertMetric,
        url: this.alertUrl,
        silence: silenceLength != 0,
        silence_until: silenceUntil,
      };
      await axios.post('/api/v1/silencealert/', payload);

      // Update the silenced status in the store
      this.updateSilencedStatus({
        source: this.alertSource,
        metric: this.alertMetric,
        url: this.alertUrl,
        is_silenced: silenceLength != 0,
      });

      this.$emit('confirm');
    },
  },
};
</script>

<style></style>
